import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface PreOrderYouTubeIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isInvertedTheme?: boolean;
}

export const PreOrderYouTubeIcon: FunctionComponent<
  PreOrderYouTubeIconProps
> = ({ className, isInvertedTheme, ...props }) => {
  const theme = useTheme();

  const getBGColor = () => {
    if (isInvertedTheme) {
      return theme.colors.differentBackground;
    }

    return theme.colors.primary;
  };

  const getLogoColor = () => {
    if (isInvertedTheme) {
      return theme.colors.primary;
    }

    return theme.colors.differentBackground;
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className || ''}
      {...props}
    >
      <path
        fill={getBGColor()}
        d="M12,0h0c6.63,0,12,5.37,12,12h0c0,6.63-5.37,12-12,12h0C5.37,24,0,18.63,0,12H0C0,5.37,5.37,0,12,0Z"
      />
      <path
        fill={getLogoColor()}
        d="M16.78,9.59c-.12-.43-.45-.77-.88-.88-.58-.22-6.18-.33-7.81,0-.43,.12-.77,.45-.88,.88-.26,1.15-.28,3.63,0,4.8,.12,.43,.45,.77,.88,.88,1.15,.26,6.59,.3,7.81,0,.43-.12,.77-.45,.88-.88,.28-1.25,.3-3.58,0-4.81Zm-5.75,3.9v-3l2.61,1.5-2.61,1.5Z"
      />
    </svg>
  );
};

export default PreOrderYouTubeIcon;
